<template>
    <div class="footer">
        <language></language>
        <address>Grid Design Tool Version 0.9 Copyright (c) 2008</address>
    </div>
</template>
<script>
import Language from "components/common/language"
export default {
    name: "Footer",
    components: {
        Language
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/footer.vue